/** Rewrite every `id="X"` in the SVG markup to `id="<prefix>-X"`, and
 * patch every reference to those ids (`url(#X)`, `href="#X"`,
 * `xlink:href="#X"`) to point at the new prefixed id.
 *
 * Why: model icons (Gemini in particular) ship with inline gradients that
 * reference an element by id, e.g. `fill="url(#SVGID_1)"`. When two such
 * icons render on the same page via `dangerouslySetInnerHTML`, both
 * declare `id="SVGID_1"`. Browsers resolve the reference to whichever
 * gradient was inserted into the document last (or first, depending on
 * the engine), and the other path renders invisible. Prefixing every id
 * with a per-render unique string keeps each icon self-contained.
 *
 * Pure regex — no DOM parsing, safe to call during render.
 */
export function makeSvgIdsUnique(svg: string, prefix?: string): string {
  if (!svg.includes('id=')) return svg;
  const uid = prefix ?? Math.random().toString(36).slice(2, 10);
  return svg
    .replace(/\bid="([^"]+)"/g, (_m, id) => `id="${uid}-${id}"`)
    .replace(/url\(#([^)]+)\)/g, (_m, id) => `url(#${uid}-${id})`)
    .replace(/\bhref="#([^"]+)"/g, (_m, id) => `href="#${uid}-${id}"`)
    .replace(/\bxlink:href="#([^"]+)"/g, (_m, id) => `xlink:href="#${uid}-${id}"`);
}
